import { render, staticRenderFns } from "./CardPosicionamentoAssinatura.vue?vue&type=template&id=3296a25a"
import script from "./CardPosicionamentoAssinatura.vue?vue&type=script&lang=js"
export * from "./CardPosicionamentoAssinatura.vue?vue&type=script&lang=js"
import style0 from "./CardPosicionamentoAssinatura.vue?vue&type=style&index=0&id=3296a25a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports